import { TenderPriceDetails } from "@/graphql/__generated__/graphql";
import { getTenderKpiItems } from "../../helpers";
import { useTranslation } from "react-i18next";
import { useIntl } from "react-intl";
import { Card, CardHeader, CardTitle } from "@/components/ui/card";
import { TextInfoGroupAlt } from "@/components/shared";

function TenderKpiSection({ tenderPriceDetails }: { tenderPriceDetails: TenderPriceDetails }) {
  const { t } = useTranslation();
  const intl = useIntl();

  const metrics = getTenderKpiItems({ t, intl, tenderPriceDetails });

  return (
    <Card className="shadow-none p-4">
      <CardHeader className="p-0 pb-4">
        <CardTitle className="text-sm font-bold">{t("edittender.calculationoverview.labels.overview")}</CardTitle>
      </CardHeader>
      <div className="grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))" }}>
        {metrics.map((metric) => (
          <TextInfoGroupAlt
            key={metric.label}
            label={metric.label}
            content={metric.content}
            hasBackground={true}
            backgroundColor="slate"
            tooltip={metric.tooltip}
          />
        ))}
      </div>
    </Card>
  );
}

export default TenderKpiSection;
